export { default } from './Label';
export type { Props, Props as LabelProps } from './Label';
